export { default as LogoDark } from '../assets/logo/logo_dark.svg?react';
export { default as LogoLight } from '../assets/logo/logo_light.svg?react';

export { default as SymbolCurrent } from '../assets/logo/symbol_current.svg?react';
export { default as SymbolWhite } from '../assets/logo/symbol_white.svg?react';

export { default as ZetaProLogo } from '../assets/logo/zeta_pro_logo.svg?react';
